<template>
  <div class="component_card">
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column">
          <h1 class="text_lg p0 tal_c">
            <strong>{{$t("msg.redeem")}}</strong>
          </h1>
          <div class="column tal_c">
            <p v-html="$t('msg.info_redeem_step_3')"></p>
          </div>
          <div class="column">
            <p>{{$t("msg.redeem_pin")}}</p>
            <input class="amount_redeem" type="text" v-model="pin" style="width:100%;" />
            <p class="text_sm">
              {{$t("msg.check_your_email_for_pin_redeem")}}
              {{$t("msg.if_no_email_spam")}}
            </p>
          </div>
          <div class="column">
            <p>{{$t("msg.redeem_2fa")}}</p>
            <input class="amount_redeem" type="text" v-model="twoFA" style="width:100%;" />
          </div>
          <div class="column">
            <button
              class="btn_redeem"
              style="width:100%;"
              @click="confirmRedeem()"
              :disabled="!pin || !twoFA || loading"
            >{{$t("msg.redeem")}}</button>
            <button
              class="btn_redeem_back"
              style="background:#e12d2d; width:100%;"
              @click="cancelRedeem()"
            >{{$t("msg.cancel_redeem")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["redeemData", "loading"],
  created() {},
  mounted() {},
  data: () => ({
    pin: "",
    twoFA: ""
  }),
  components: {},
  methods: {
    confirmRedeem() {
      let redeem = {
        e2faCode: this.twoFA,
        id: "",
        pinCode: this.pin
      };
      this.loading = true;
      this.$emit("confirmRedeem", redeem);
    },

    cancelRedeem() {
      this.$emit("cancelRedeem");
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    pin: function() {
      this.loading = false;
    },
    twoFA: function() {
      this.loading = false;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/RedeemStep3.vue